import { cn } from "@src/shared/lib/utils";

export interface VisitRecordingAudioLevelMeterProps {
  levels?: number[];
  isActive: boolean;
}

export function VisitRecordingAudioLevelMeter({
  levels,
  isActive,
}: VisitRecordingAudioLevelMeterProps) {
  const displayLevels =
    levels && levels.length > 0 ? levels : Array.from({ length: 10 }, () => 0);
  const currentLevel = isActive ? Math.max(...displayLevels) : 0;
  const currentPercent = Math.round(currentLevel * 100);

  return (
    <div
      aria-label="Microphone input level"
      aria-valuemax={100}
      aria-valuemin={0}
      aria-valuenow={currentPercent}
      className="flex h-7 shrink-0 items-center"
      role="meter"
    >
      <div className="flex h-5 items-center gap-0.5" aria-hidden="true">
        {displayLevels.map((level, index) => (
          <span
            className={cn(
              "w-1 rounded-sm bg-muted-foreground/30 transition-[height,background-color]",
              isActive && "bg-success",
            )}
            key={`${index}-${Math.round(level * 100)}`}
            style={{ height: Math.max(5, Math.round(level * 26)) }}
          />
        ))}
      </div>
    </div>
  );
}
